var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/polls/poll-form.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { addPollOption, changePollOption, changePollSettings, clearComposeSuggestions, fetchComposeSuggestions, removePoll, removePollOption, selectComposeSuggestion } from 'soapbox/actions/compose';
import AutosuggestInput from 'soapbox/components/autosuggest_input';
import { Button, Divider, HStack, Stack, Text, Toggle } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
import DurationSelector from './duration-selector';
const messages = defineMessages({
  option_placeholder: {
    "id": "compose_form.poll.option_placeholder",
    "defaultMessage": "Answer #{number}"
  },
  add_option: {
    "id": "compose_form.poll.add_option",
    "defaultMessage": "Add an answer"
  },
  remove_option: {
    "id": "compose_form.poll.remove_option",
    "defaultMessage": "Remove this answer"
  },
  pollDuration: {
    "id": "compose_form.poll.duration",
    "defaultMessage": "Duration"
  },
  removePoll: {
    "id": "compose_form.poll.remove",
    "defaultMessage": "Remove poll"
  },
  switchToMultiple: {
    "id": "compose_form.poll.switch_to_multiple",
    "defaultMessage": "Change poll to allow multiple answers"
  },
  switchToSingle: {
    "id": "compose_form.poll.switch_to_single",
    "defaultMessage": "Change poll to allow for a single answer"
  },
  minutes: {
    "id": "intervals.full.minutes",
    "defaultMessage": "{number, plural, one {# minute} other {# minutes}}"
  },
  hours: {
    "id": "intervals.full.hours",
    "defaultMessage": "{number, plural, one {# hour} other {# hours}}"
  },
  days: {
    "id": "intervals.full.days",
    "defaultMessage": "{number, plural, one {# day} other {# days}}"
  },
  multiSelect: {
    "id": "compose_form.poll.multiselect",
    "defaultMessage": "Multi-Select"
  },
  multiSelectDetail: {
    "id": "compose_form.poll.multiselect_detail",
    "defaultMessage": "Allow users to select multiple answers"
  }
});
const Option = props => {
  const {
    index,
    maxChars,
    numOptions,
    onChange,
    onRemove,
    onRemovePoll,
    title
  } = props;
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const suggestions = useAppSelector(state => state.compose.suggestions);
  const handleOptionTitleChange = event => onChange(index, event.target.value);
  const handleOptionRemove = () => {
    if (numOptions > 2) {
      onRemove(index);
    } else {
      onRemovePoll();
    }
  };
  const onSuggestionsClearRequested = () => dispatch(clearComposeSuggestions());
  const onSuggestionsFetchRequested = token => dispatch(fetchComposeSuggestions(token));
  const onSuggestionSelected = (tokenStart, token, value) => {
    if (token && typeof token === 'string') {
      dispatch(selectComposeSuggestion(tokenStart, token, value, ['poll', 'options', index]));
    }
  };
  return /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    justifyContent: "between",
    space: 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 2,
    grow: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 11
    }
  }, index + 1, ".")), /*#__PURE__*/React.createElement(AutosuggestInput, {
    className: "rounded-md",
    placeholder: intl.formatMessage(messages.option_placeholder, {
      number: index + 1
    }),
    maxLength: maxChars,
    value: title,
    onChange: handleOptionTitleChange,
    suggestions: suggestions,
    onSuggestionsFetchRequested: onSuggestionsFetchRequested,
    onSuggestionsClearRequested: onSuggestionsClearRequested,
    onSuggestionSelected: onSuggestionSelected,
    searchTokens: [':'],
    autoFocus: index === 0 || index >= 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 9
    }
  })), index > 1 && /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "danger",
    size: "sm",
    onClick: handleOptionRemove,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 11
    }
  }, "Delete")));
};
const PollForm = () => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const pollLimits = useAppSelector(state => state.instance.getIn(['configuration', 'polls']));
  const options = useAppSelector(state => state.compose.poll?.options);
  const expiresIn = useAppSelector(state => state.compose.poll?.expires_in);
  const isMultiple = useAppSelector(state => state.compose.poll?.multiple);
  const maxOptions = pollLimits.get('max_options');
  const maxOptionChars = pollLimits.get('max_characters_per_option');
  const onRemoveOption = index => dispatch(removePollOption(index));
  const onChangeOption = (index, title) => dispatch(changePollOption(index, title));
  const handleAddOption = () => dispatch(addPollOption(''));
  const onChangeSettings = (expiresIn, isMultiple) => dispatch(changePollSettings(expiresIn, isMultiple));
  const handleSelectDuration = value => onChangeSettings(value, isMultiple);
  const handleToggleMultiple = () => onChangeSettings(expiresIn, !isMultiple);
  const onRemovePoll = () => dispatch(removePoll());
  if (!options) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 7
    }
  }, options.map((title, i) => /*#__PURE__*/React.createElement(Option, {
    title: title,
    key: i,
    index: i,
    onChange: onChangeOption,
    onRemove: onRemoveOption,
    maxChars: maxOptionChars,
    numOptions: options.size,
    onRemovePoll: onRemovePoll,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 11
    }
  }), options.size < maxOptions && /*#__PURE__*/React.createElement(Button, {
    theme: "secondary",
    onClick: handleAddOption,
    size: "sm",
    block: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.add_option, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 156,
      columnNumber: 15
    }
  }))))), /*#__PURE__*/React.createElement(Divider, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 162,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("button", {
    onClick: handleToggleMultiple,
    className: "text-left",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    justifyContent: "between",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 165,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 167,
      columnNumber: 13
    }
  }, intl.formatMessage(messages.multiSelect)), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 13
    }
  }, intl.formatMessage(messages.multiSelectDetail))), /*#__PURE__*/React.createElement(Toggle, {
    checked: isMultiple,
    onChange: handleToggleMultiple,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 176,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Divider, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 180,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 183,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 184,
      columnNumber: 9
    }
  }, intl.formatMessage(messages.pollDuration)), /*#__PURE__*/React.createElement(DurationSelector, {
    onDurationChange: handleSelectDuration,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 188,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 192,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "danger-link",
    onClick: onRemovePoll,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 193,
      columnNumber: 9
    }
  }, intl.formatMessage(messages.removePoll))));
};
export default PollForm;